import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UserService } from '../../../services/core.user.service';
import { UiService } from '../../../services/core.ui.service';
import { StateService } from '@uirouter/angular';

@Component({
  selector: 'gf-user-delete-modal',
  template: require('./delete.user.modal.component.html')
})
export class UserDeleteModalComponent implements OnInit {
  @Input() user: any;
  @Output() onClose = new EventEmitter<any>();
  @Output() onDelete = new EventEmitter<any>();

  deleteData: any = { deleteConfirm: '' };

  constructor(
    private fb: UntypedFormBuilder,
    private userService: UserService,
    private uiService: UiService,
    private stateService: StateService, 
    
  ) {}

  ngOnInit(): void {
  }

  close(): void {
    this.onClose.emit();
  }

  delete(): void {
    this.onDelete.emit();
  }
}

